export default {
	tab: "Reservations",
	reserveConsultant: "Reserve consultant",
	pending: "Pending",
	confirmed: "Email confirmed",
	awaitingConfirm: "Email not confirmed",
	receivedAt: "Received on",
	noEmailStatus: "No email",
	viewDetails: "View details",
	phone: "Phone",
	email: "Email",
	approve: "Approve",
	reject: "Reject",
	expected: "Reserved",
	noExpected: "No one reserved yet.",
	noPending: "No pending reservations.",
	noRejected: "No rejected reservations.",
	originPublic: "Public",
	originInternal: "Internal",
	rejected: "Rejected",
	approveTitle: "Approve reservation",
	linkExisting: "Existing consultant",
	createNew: "Register new",
	consultant: "Consultant",
	attendanceType: "Service type",
	groupByType: "Group by attendance type",
	noType: "No type",
	attendanceTypeHint: "The reservation guarantees a ticket of this type; full types are unavailable.",
	unlimited: "no limit",
	full: "full",
	selectType: "Select the service type.",
	firstName: "First name",
	lastName: "Last name",
	rejectTitle: "Reject reservation",
	rejectReason: "Reason (optional)",
	notes: "Note (optional)",
	reserve: "Reserve",
	reserved: "Consultant reserved!",
	approved: "Reservation approved!",
	rejectedDone: "Reservation rejected.",
	loadError: "Error loading reservations.",
	saveError: "Could not complete. Please try again.",
	selectConsultant: "Select the consultant.",
	firstNameRequired: "Enter the name.",
	attended: "Attended",
	cancelReservation: "Cancel reservation",
	editTitle: "Edit reservation",
	cancelTitle: "Cancel reservation",
	cancelConfirm: 'Cancel the reservation for "{name}"? The slot will be freed.',
	saved: "Reservation updated!",
	cancelled: "Reservation cancelled.",
	exportExcel: "Excel",
	printTitle: "Ritual reservations",
	origin: "Origin",
	status: "Status",
	awaitingAttendance: "Awaiting",
	contact: "Contact",
};
